var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconsAttachmentOutlineBrand(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Labels"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.61,86A18.13,18.13,0,0,1,23.72,56.24q8-9.43,15.86-18.86T55.43,18.54a13.27,13.27,0,0,1,18.65-1.32,13.12,13.12,0,0,1,1.6,18.24L44.25,72.75A8.18,8.18,0,0,1,31.7,62.27L60.29,28.34l3.42,2.86L35.14,65.12a3.7,3.7,0,0,0,.44,5.23,3.74,3.74,0,0,0,5.25-.44L72.23,32.6A8.68,8.68,0,0,0,71,20.34a8.77,8.77,0,0,0-11.19.11,7.08,7.08,0,0,0-.84.89,2.5,2.5,0,0,1-.27.34L27.14,59.1a13.72,13.72,0,0,0,21,17.64l1.73-2,22-26.14,5-5.95.21-.25,3.41,2.85-29,34.4A18.11,18.11,0,0,1,39.24,86C38.7,86,38.15,86,37.61,86Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsAttachmentOutlineBrand);
export default __webpack_public_path__ + "static/media/Icons_Attachment_Outline_Brand.0f21b9852f0cf8cabc449424d87e4f1d.svg";
export { ForwardRef as ReactComponent };